<template>
  <div class="document-container" style="padding: 1rem 0rem">
    <div class="columns is-desktop">
      <div class="column is-half">
        <rule-manager-dm-match-and-assign-rules/>
      </div>
    </div>
  </div>
</template>

<script>
import RuleManagerDmMatchAndAssignRules from '@/components/RuleManagerDmMatchAndAssignRules.vue';

export default {
  components: {
    RuleManagerDmMatchAndAssignRules,
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
</style>
